import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { AuthService } from '../../../services/auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);

    // Check the authentication status
    return authService.isUserLoggedIn().pipe(
        switchMap((authenticated) => {
            //console.log(authenticated);
            // If the user is not authenticated...
            if (!authenticated) {
                const redirectURL =
                    state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);
                return of(urlTree);
            }

            // Check for route permissions
            const requiredPermissions: string[] =
                route.data?.['permissions'] || [];
            if (requiredPermissions.length > 0) {
                const hasAllPermissions = requiredPermissions.every(
                    (permission) => authService.userHasPermission(permission)
                );

                if (!hasAllPermissions) {
                    // Redirect to unauthorized page if permissions fail
                    const urlTree = router.parseUrl('unauthorised');
                    return of(urlTree);
                }
            }

            // Allow the access
            return of(true);
        })
    );
};
